import type { AllowedTags } from './types'

export interface HtmlProps {
  as?: AllowedTags
  children: string
  className?: string
}

const HTML = ({ children, as = 'span', className }: HtmlProps) => {
  const Tag = as

  return (
    <Tag data-test='html' className={className} dangerouslySetInnerHTML={{ __html: children }} />
  )
}

export default HTML
